import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("paste", this.trackPaste.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("paste", this.trackPaste.bind(this))
  }

  trackPaste() {
    App.analytics.posthog_capture("Pasted data", {
      field: this.element.name || this.element.id,
    })
  }
}
